export default "__VITE_ASSET__CS8$M_jZ__"